<template>
  <div id="first-screen" :class="{ fade, fadeIn }" :style="{ backgroundColor: '#004665' }">
    <div class="mid">
      <div class="square">
        <div class="title">Olá, seja bem-vindo(a)<br />ao Trilhas de Carreira!</div>
        <div class="button">
          <button v-for="(f, i) in fronts" :key="f.name" :value="f.file" @click="frontSelected">Iniciar</button>
        </div>
        <div class="logos">
          <img :src="LogoFTD" height="33" alt="logo ftd">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import FundoInicio from 'Assets/images/fundo-inicio.jpg';
  import LogoMarista from 'Assets/images/logo-grupo.png';
  import LogoFTD from 'Assets/images/logo-ftd.png';
  import LogoDHO from 'Assets/images/logo-dho.png';
  import Arrow from 'Assets/images/arrow.svg';

  export default {
    components: {},

    props: {},
    data() {
      return {
        FundoInicio,
        LogoMarista,
        LogoFTD,
        LogoDHO,
        Arrow,
        fronts: window.$fronts || [],
        currentFront: 'Selecione',
        fade: false,
        fadeIn: false,
      };
    },
    created() {
      EventSystem.$on('fronts-loaded', this.updateSelect);
      EventSystem.$on('go-back-to-first-screen-why---cause-they-said-so', () => this.showAgain());
    },

    computed: {},
    methods: {
      updateSelect(front) {
        this.fronts = window.$fronts;
      },
      frontSelected(evt) {
        const front = this.fronts.find(f => f.file === evt.currentTarget.value);
        this.currentFront = front.name;
        EventSystem.$emit('first-front-selected', front);
        this.fade = true;
        this.fadeIn = false;
      },
      showAgain() {
        this.fade = false;
        this.fadeIn = true;
        this.currentFront = 'Selecione';
      }
    },
  };
</script>





// WEBPACK FOOTER //
// assets/js/source/vue-ui/selection.vue